import "~/scss/page-templates/betterThreeD.scss";

import _ from "underscore";
import { getElementHeight } from "~/js/lib/utils";

console.log("betterThreeD");

const betterThreeDSectionsEl:NodeListOf<HTMLElement>|null = document.querySelectorAll(".section__better-threed__get-ready");

let betterThreeDSections:any[] = [];

if( betterThreeDSectionsEl !== null ) {
  for( let i=0; i<betterThreeDSectionsEl.length; i++ ) {
    let copyContent:HTMLElement|null = betterThreeDSectionsEl[i].querySelector(".better-threed__content");
    let imageContentContainer:HTMLElement|null = betterThreeDSectionsEl[i].querySelector(".better-threed__image-content");
    let imageContent:HTMLElement|null = betterThreeDSectionsEl[i].querySelector(".better-threed__image-content .better-threed__image-img");

    if( copyContent !== null && imageContent !== null ) {
      betterThreeDSections.push(
        {
          copyContent: copyContent,
          imageContentContainer: imageContentContainer,
          imageContent: imageContent,
          imageContentOriginalWidth: 1060,
          imageContentOriginalHeight: 600
        }
      )
    }
  }
}


function resize() {

  let browserWidth = window.innerWidth;

  let minHeight = 450;
  if( browserWidth >= 1720 ) {
    minHeight = 350;
  } else if( browserWidth >= 1536 ) {
    minHeight = 350;
  } else if( browserWidth >= 1280 ) {
    minHeight = 325;
  } else if( browserWidth >= 1024 ) {
    minHeight = 300;
  } else if( browserWidth >= 768 ) {
    minHeight = 300;
  }

  for( let i=0; i<betterThreeDSections.length; i++ ) {
    if( window.innerWidth >= 768 ) {
      let header:HTMLElement|null = betterThreeDSections[i].copyContent.querySelector(".better-threed__content__header-container");
      let copy:HTMLElement|null = betterThreeDSections[i].copyContent.querySelector(".better-threed__content__copy");
      let buttons:HTMLElement|null = betterThreeDSections[i].copyContent.querySelector(".better-threed__buttons-list");

      let copyContentHeight = 0;
      if( header ) {
        let headerHeight = getElementHeight(header);
        copyContentHeight += headerHeight !== null ? headerHeight : 0;
      }

      if( copy ) {
        let copyHeight = getElementHeight(copy);
        copyContentHeight += copyHeight !== null ? copyHeight : 0;
      }

      if( buttons ) {
        let buttonsHeight = getElementHeight(buttons);
        copyContentHeight += buttonsHeight !== null ? buttonsHeight : 0;
      }

      if( copyContentHeight < minHeight ) {
        copyContentHeight = minHeight;
      }

      let height = copyContentHeight;
      if( height < betterThreeDSections[i].imageContentContainer.clientHeight ) {
        // height = betterThreeDSections[i].imageContentContainer.clientHeight;
      }

      let ratioY:number = height / betterThreeDSections[i].imageContentOriginalHeight;

      console.log('height:', height);
      console.log('ratioY:', ratioY);

      let width = Math.round(ratioY * betterThreeDSections[i].imageContentOriginalWidth);
      console.log('new width:', width);
      console.log('imageContentContainer.width:', betterThreeDSections[i].imageContentContainer.clientWidth);
      if( width < betterThreeDSections[i].imageContentContainer.clientWidth ) {
        // width = betterThreeDSections[i].imageContentContainer.clientWidth;
      } else if( width > betterThreeDSections[i].imageContentContainer.clientWidth * 1.0 ) {
        width = Math.round(betterThreeDSections[i].imageContentContainer.clientWidth * 1.0);
      }
      console.log('updated width:', width);

      betterThreeDSections[i].imageContent.style.width = width+'px';

    } else {
      betterThreeDSections[i].imageContent.style.width = '100%';
    }
  }
}


let resizeThrottled = _.throttle(() => {
  // resize();
}, 200);

window.addEventListener('resize', () => {
  resizeThrottled();
})

document.addEventListener('DOMContentLoaded', () => {
  // setTimeout(() => {
  //   resize();
  // }, 100);
});